import type { SVGProps } from 'react';

const SvgClosedEye = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 2L18 18"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.6671 8.82422C8.39048 9.13755 8.22266 9.54929 8.22266 10.0001C8.22266 10.9819 9.01857 11.7779 10.0004 11.7779C10.4513 11.7779 10.8629 11.6101 11.1763 11.3335"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.8772 6.05469C4.38224 7.10231 3.13684 8.59487 2 10.0004C3.67872 12.659 6.69484 15.3337 10 15.3337C11.3777 15.3337 12.7052 14.869 13.9066 14.1344"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 4.66699C13.563 4.66699 15.9569 7.47428 18 10.0003C17.7169 10.4486 17.3958 10.8974 17.0418 11.3337"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default SvgClosedEye;
